var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAddRangePlus = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-8cc8bc09-7f32-46db-8be2-d5076ab54525",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none",
    opacity: 0,
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.061,4.491c-.611-1.058-1.49-1.936-2.547-2.547-1.069-.615-2.28-.939-3.514-.939s-2.445.324-3.514.939c-1.058.611-1.937,1.489-2.548,2.547-.615,1.069-.939,2.28-.939,3.514s.324,2.445.939,3.514c.611,1.058,1.49,1.936,2.548,2.547,1.069.615,2.28.939,3.514.939s2.445-.324,3.514-.939c1.058-.611,1.936-1.49,2.547-2.547.615-1.069.939-2.28.939-3.514s-.324-2.445-.939-3.514Zm-1.978,4.097c-.002.154-.064.301-.173.41-.109.109-.256.171-.41.173h-2.333v2.333c-.002.154-.064.301-.173.41-.109.109-.256.171-.41.173h-1.167c-.154-.002-.301-.064-.41-.173-.109-.109-.171-.256-.173-.41v-2.333h-2.333c-.154-.002-.301-.064-.41-.173-.109-.109-.171-.256-.173-.41v-1.167c.002-.154.064-.301.173-.41.109-.109.256-.171.41-.173h2.333v-2.333c.002-.154.064-.301.173-.41.109-.109.256-.171.41-.173h1.167c.154.002.301.064.41.173s.171.256.173.41v2.333h2.333c.154.002.301.064.41.173s.171.256.173.41v1.167Z",
    fill: "#118af9",
    strokeWidth: 0
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddRangePlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add-range-plus.7f41acde.svg";
export { ForwardRef as ReactComponent };